import * as creativeActions from "./creativesActions";
import * as creativeAsyncActions from "./creativesAsyncActions";
import { creativesSlice } from "./creativesSlice";

export const actions = {
  ...creativeActions,
  ...creativeAsyncActions,
  ...creativesSlice.actions,
};
